import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  InputAdornment,
  Button,
  Dialog,
  DialogContent,
} from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Field, reduxForm, getFormSyncErrors, getFormValues } from "redux-form";
import { phone as phoneFormatter } from "components/FormFields/formatters";
import { renderTextField } from "components/FormFields/FieldTypes";
import {
  Required,
  PasswordMatch,
  PasswordValidityMatch,
  OTPPassword,
} from "components/FormFields/validators";

import { homeActions, authenticationActions } from "actions";
import ResentDialog from "components/ResentDialog";
import { homeService } from "services/home.service";

const VerifyPassword = (props) => {
  const theme = useTheme();

  const {
    formErrors,
    formValues,
    signUpParams,
    signUpInfo,
    verifyPasswordChange,
    verifyPasswordInfo,
    verifyResendPasswordChange,
    verifyResendPasswordInfo,
    updateGTMDataLayer,
    gtmInfo,
    signIn,
    loginStatus,
    loginEncUser,
    authenticateDevice,
    loginData,
  } = props;
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showResendSuccess, setShowResendSuccess] = useState(false);
  const [resentMessage, setResentMessage] = useState("");
  const [encUser, setEncuser] = useState(null);
  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const encuserQueryParam = params.get("encuser");
  const history = useHistory();

  const onFormSubmit = () => {
    const attemptID =
      verifyResendPasswordInfo &&
      verifyResendPasswordInfo.data &&
      Object.keys(verifyResendPasswordInfo.data).length
        ? verifyResendPasswordInfo.data.data
        : signUpInfo.data;

    verifyPasswordChange({
      signupAttemptId: attemptID,
      temporaryPassword: formValues.currentPassword,
      password: formValues.newPassword,
    });
  };

  const getEncuserData = async (encuserData) => {
    console.log(encuserData);
    const response = await homeService?.getEncUserInfo(encuserData);
    if (response?.data?.alreadySignedUp) {
      history.push("/SignIn", {
        ...response?.data,
      });
    }
    setEncuser(response?.data);
  };
  useEffect(() => {
    if (encuserQueryParam) {
      getEncuserData(encuserQueryParam);
    }

    document.getElementById("appcontent").scroll(0, 0);
    updateGTMDataLayer({
      page: "Global",
      screen: "Home",
      screen_title: "Global",
      event: "Sign_up_form_email_enter_confirm_password",
    });
    return () => {
      updateGTMDataLayer({
        event: "Sign_up_form_email_enter_confirm_password",
        screen_referrer: "home",
      });
    };
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  useEffect(() => {
    if (
      verifyPasswordInfo &&
      verifyPasswordInfo.data &&
      Object.keys(verifyPasswordInfo.data).length
    ) {
      setShowSuccess(true);
    }
  }, [verifyPasswordInfo]);

  useEffect(() => {
    if (
      verifyResendPasswordInfo &&
      verifyResendPasswordInfo.data &&
      Object.keys(verifyResendPasswordInfo.data).length
    ) {
      setShowResendSuccess(true);
      setResentMessage(verifyResendPasswordInfo.data.message);
    }
  }, [verifyResendPasswordInfo]);

  useEffect(() => {
    if ((loginStatus === false || loginStatus === true) && !encuserQueryParam) {
      history.push("/");
    }
    if (encuserQueryParam && loginStatus === true && loginData?.refreshToken) {
      authenticateDevice(loginData?.refreshToken);
      history.push("/", { ...encUser });
    }
  }, [loginStatus]);

  const resendAgain = () => {
    if (signUpInfo && signUpInfo.data) {
      verifyResendPasswordChange(signUpInfo.data);
    }
  };

  const onSignUpSuccess = () => {
    const params = {
      refreshToken: JSON.parse(sessionStorage.getItem("refreshToken")),
      password: formValues.newPassword,
    };
    if (encUser && encuserQueryParam) {
      if (encUser?.phone) {
        params.phone = encUser.phone;
      } else {
        params.email = encUser?.email;
      }
    } else if (signUpParams?.phone) {
      params.phone = signUpParams.phone;
    } else {
      params.email = signUpParams?.email;
    }
    signIn(params);
  };

  const ssoLogin = () => {
    const params = {
      refreshToken: JSON.parse(sessionStorage.getItem("refreshToken")),
      password: formValues.newPassword,
      encUser: encuserQueryParam,
    };

    loginEncUser(params);
  };

  const successId = signUpParams?.email ? "successEmail" : "successMobile";

  return (
    <SecondaryCenterTemplate
      pageTitle={encuserQueryParam ? "Create Password" : "Verify Password"}
    >
      <Grid container>
        <Grid item xs={12} sm={8} sx={{ margin: "auto" }}>
          <form>
            {!encuserQueryParam && (
              <>
                <Box mb={1} mt={5} sx={{ textAlign: "center" }}>
                  <Typography variant="h3LatoRegular">
                    We sent a temporary password to:
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "center" }} mb={4}>
                  <Typography variant="text2">
                    {signUpParams &&
                      (signUpParams.email ||
                        phoneFormatter(signUpParams.phone))}
                  </Typography>
                </Box>
              </>
            )}
            {encuserQueryParam && encUser?.username && (
              <>
                <Box mb={1} mt={5} sx={{ textAlign: "center" }}>
                  <Typography variant="h3LatoRegular">
                    Registered through :
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "center" }} mb={4}>
                  <Typography variant="text2">
                    {encUser && encUser?.type == "phone"
                      ? phoneFormatter(encUser.username)
                      : encUser?.username}
                  </Typography>
                </Box>
              </>
            )}
            <Grid item container alignItems="center" justifyContent="center">
              {!encuserQueryParam && (
                <>
                  <Grid
                    item
                    xs={12}
                    pb={4}
                    pt={0}
                    id={
                      signUpParams && signUpParams.email
                        ? "emailPassword"
                        : "mobilePassword"
                    }
                  >
                    <Field
                      name="currentPassword"
                      isRequired
                      component={renderTextField}
                      label="Please enter the temporary password"
                      type={showCurrentPassword ? "text" : "password"}
                      validate={[Required, OTPPassword]}
                      handleKeyDown={(e) => {
                        if (
                          e.key &&
                          e.key == "Enter" &&
                          Object.keys(formErrors).length == 0
                        ) {
                          onFormSubmit();
                        }
                      }}
                      endIcon={
                        <InputAdornment
                          position="end"
                          onClick={() => {
                            setShowCurrentPassword(!showCurrentPassword);
                          }}
                        >
                          {showCurrentPassword ? (
                            <Visibility
                              sx={{ color: theme.palette.primary.main }}
                            />
                          ) : (
                            <VisibilityOff
                              sx={{ color: theme.palette.primary.main }}
                            />
                          )}
                        </InputAdornment>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} pb={4} pt={0}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="text3"
                        sx={{
                          color: theme.palette.common.greenThree,
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => resendAgain()}
                        disabled={Object.keys(formErrors).length ? true : false}
                      >
                        Resend temporary password
                      </Typography>
                    </Box>
                  </Grid>
                </>
              )}

              <Grid item xs={12} pb={4} pt={0}>
                <Field
                  name="newPassword"
                  isRequired
                  component={renderTextField}
                  label="Please select a new memorable password"
                  type={showNewPassword ? "text" : "password"}
                  helperText="6 character minimum, 1 capital letter, 1 number"
                  validate={[Required, PasswordMatch, PasswordValidityMatch]}
                  handleKeyDown={(e) => {
                    if (
                      e.key &&
                      e.key == "Enter" &&
                      Object.keys(formErrors).length == 0
                    ) {
                      encUser && encuserQueryParam
                        ? ssoLogin()
                        : onFormSubmit();
                    }
                  }}
                  endIcon={
                    <InputAdornment
                      position="end"
                      onClick={() => {
                        setShowNewPassword(!showNewPassword);
                      }}
                    >
                      {showNewPassword ? (
                        <Visibility
                          sx={{ color: theme.palette.primary.main }}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{ color: theme.palette.primary.main }}
                        />
                      )}
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                pb={4}
                pt={0}
                id={
                  signUpParams && signUpParams.email
                    ? "signupConfirmEmail"
                    : "signupConfirmMobile"
                }
              >
                <Field
                  name="confirmPassword"
                  isRequired
                  component={renderTextField}
                  label="Please confirm your new password"
                  type={showConfirmPassword ? "text" : "password"}
                  validate={[Required, PasswordMatch, PasswordValidityMatch]}
                  handleKeyDown={(e) => {
                    if (
                      e.key &&
                      e.key == "Enter" &&
                      Object.keys(formErrors).length == 0
                    ) {
                      encUser && encuserQueryParam
                        ? ssoLogin()
                        : onFormSubmit();
                    }
                  }}
                  endIcon={
                    <InputAdornment
                      position="end"
                      onClick={() => {
                        setShowConfirmPassword(!showConfirmPassword);
                      }}
                    >
                      {showConfirmPassword ? (
                        <Visibility
                          sx={{ color: theme.palette.primary.main }}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{ color: theme.palette.primary.main }}
                        />
                      )}
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                sx={{ margin: "auto", marginTop: "54px", textAlign: "center" }}
              >
                <Box>
                  <Typography variant="h4LatoRegular">
                    By continuing to use this website, you agree to the Cuverd®
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="h4LatoRegular"
                    sx={{ color: theme.palette.common.greenThree }}
                    component={Link}
                    to="/terms-and-conditions"
                  >
                    Terms and Conditions
                  </Typography>
                  <Typography variant="h4LatoRegular">
                    &nbsp;and&nbsp;
                  </Typography>
                  <Typography
                    variant="h4LatoRegular"
                    component={Link}
                    to="/privacy-policy"
                    sx={{ color: theme.palette.common.greenThree }}
                  >
                    Privacy Policy
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={10}
                sx={{
                  margin: "auto",
                  marginTop: "34px",
                  textAlign: "center",
                  marginBottom: { xs: "20px", sm: "20px", md: "80px" },
                }}
              >
                <Box>
                  <Button
                    variant="large"
                    type="button"
                    onClick={() => {
                      encUser && encuserQueryParam
                        ? ssoLogin()
                        : onFormSubmit();
                    }}
                    disabled={Object.keys(formErrors).length ? true : false}
                    sx={{
                      minWidth: "100%",
                      backgroundColor:
                        formErrors && Object.keys(formErrors).length
                          ? "#e6e6e6"
                          : undefined,
                      color:
                        formErrors && Object.keys(formErrors).length
                          ? "#637276"
                          : undefined,
                      boxShadow: "none",
                    }}
                  >
                    SAVE NEW PASSWORD
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
          {verifyResendPasswordInfo ? (
            <ResentDialog
              showResentDialog={showResendSuccess}
              resentMessage={resentMessage}
              onResentClick={() => {
                setShowResendSuccess(false);
              }}
            />
          ) : null}
          {showSuccess ? (
            <Dialog open={showSuccess} className="info-dialog">
              <DialogContent sx={{ padding: "40px" }}>
                <Box mt={2}>
                  <Typography variant="text4">
                    {verifyPasswordInfo &&
                      verifyPasswordInfo.data &&
                      verifyPasswordInfo.data.message}
                  </Typography>
                </Box>
                <Box mt={1} mb={3}>
                  <Typography variant="text2">
                    {signUpParams &&
                      (signUpParams.email ||
                        phoneFormatter(signUpParams.phone))}
                  </Typography>
                </Box>
                <Box mt={10} mb={2} id={successId}>
                  <Button
                    variant="large"
                    sx={{ minWidth: { xs: "100%", sm: "100%", md: undefined } }}
                    onClick={() => {
                      onSignUpSuccess();
                      setShowSuccess(false);
                    }}
                  >
                    DONE
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
          ) : null}
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("VERIFY_PASSWORD_FORM")(state) || {},
    formValues: getFormValues("VERIFY_PASSWORD_FORM")(state),
    OTPValues: getFormValues("OTP_FIELD")(state),
    signUpInfo: state.signUp.data,
    signUpParams: state.signUp.signUpParams,
    verifyResendPasswordInfo: state.verifyResendPassword,
    verifyPasswordInfo: state.verifyPasswordInfo,
    gtmInfo: state.gtmInfo.data,
    loginStatus: state.signIn.loginStatus,
    loginData: state.signIn.data,
  };
};

const mapDispatchToProps = {
  verifyPasswordChange: (params) => homeActions.verifyPasswordChange(params),
  verifyResendPasswordChange: (params) =>
    homeActions.verifyResendPasswordChange(params),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  signIn: (params) => homeActions.signIn(params),
  loginEncUser: (params) => homeActions.loginEncUser(params),
  authenticateDevice: (value) =>
    authenticationActions.authenticateDevice(value),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "VERIFY_PASSWORD_FORM",
  })(VerifyPassword)
);
